export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700italic-9360531f9bb817f917f01a6d394515f3.woff";